import * as React from 'react'
export interface IDividerProps {
  tag?: string
  width: number | string
  height: number | string
  color?: string
  className?: string
  style?: React.CSSProperties
}
export default function Divider({
  tag = 'span',
  width,
  height,
  color = '#E6E8F2',
  className,
  style,
}: IDividerProps) {
  const Tag = tag as any
  const mergedStyle: React.CSSProperties = {
    display: 'inline-block',
    width,
    height,
    background: color,
    ...style,
  }
  return <Tag style={mergedStyle} className={className} />
}
